"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import useAuthStore from "@/stores/useAuthStore";

// Tipos para métodos de Brevo/Sendinblue
type BrevoMethod = "track" | "identify" | "trackLink" | "page";

export default function BrevoTracker() {
  const pathname = usePathname();

  useEffect(() => {
    const executeBrevoTracker = () => {
      let email: string | undefined;
      const { userData } = useAuthStore.getState();

      //console.log("BrevoTracker executed");

      window.sib = {
        equeue: [],
        client_key: "rm8lwbv89ohfnjrt21r1fe0d",
      };

      if (userData && userData.email) {
        email = userData.email;
        window.sib.email_id = email;
        //console.log("BrevoTracker", email);
      }

      // Inicializa el objeto con tipo indexable
      window.sendinblue = {} as Record<BrevoMethod, (...args: any[]) => void>;

      const methods = ["track", "identify", "trackLink", "page"] as const;
      for (const k of methods) {
        window.sendinblue[k] = function (...args: any[]) {
          (
            (window.sib as any)[k] ||
            function () {
              const t: Record<string, any> = {};
              t[k] = args;
              window.sib.equeue.push(t);
            }
          )(args[0], args[1], args[2], args[3]);
        };
      }

      const n = document.createElement("script");
      const firstScript = document.getElementsByTagName("script")[0];
      n.type = "text/javascript";
      n.id = "sendinblue-js";
      n.async = true;
      n.src = "https://sibautomation.com/sa.js?key=" + window.sib.client_key;
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(n, firstScript);
      }
      window.sendinblue.page();
    };

    executeBrevoTracker(); // Ejecutar el script inicialmente
  }, [pathname]); // Ejecutar el script cada vez que la ruta cambia

  // Función para capturar eventos personalizados
  const trackCustomEvent = (eventName: string, eventData: any) => {
    if (window.sendinblue && typeof window.sendinblue.track === "function") {
      window.sendinblue.track(eventName, eventData);
      //console.log("Se ejecuto un evento" + eventName + eventData);
    } else {
      //console.error("Brevo Tracker no está inicializado correctamente");
    }
  };

  // Exponer la función trackCustomEvent al objeto global window
  useEffect(() => {
    window.trackBrevoEvent = trackCustomEvent;
  }, []);

  return null;
}
